import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { BasePagingResponse } from "../_types";

export interface ProductGroup {
  id: number;
  name: string;
  merchantId: number;
  status: "ACTIVE" | "PASSIVE" | "FAIL" | "PENDING" | "VOID" | "START" | "SUCCESS" | "REFUND" | "EXPIRED" | "BLOCKED" | "DELETED" | "BLACKLISTED";
  systemDate: string;
  createDate: string;
  createUserId: number;
  updateDate: string | null;
  updateUserId: number;
  deleteDate: string | null;
  deleteUserId: number;
}

export interface GetProductGroupsRequest {
  page: number;
  size: number;
  orderByDesc: boolean;
  orderBy: string;
  status?: string;
}

export type GetProductGroupsResponse = BasePagingResponse<Array<ProductGroup>>;

export async function getProductGroups(
  request: GetProductGroupsRequest
): Promise<GetProductGroupsResponse> {
  try {
    return (await axiosInstance.post("/Product/GetProductGroups", request)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetProductGroups(request: Partial<GetProductGroupsRequest>) {
  const defaultRequest: GetProductGroupsRequest = {
    page: 1,
    size: 100,
    orderByDesc: true,
    orderBy: "CreateDate",
  };

  return useQuery<GetProductGroupsResponse, Error>(
    ["product", "groups", request],
    () => getProductGroups({ ...defaultRequest, ...request })
  );
}
